import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getClientes } from '../../helpers/api_helper';

const useObtenerClientes = (limit = 100, refresh = 0) => {
    const [clientes, setClientes] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);

    useEffect(() => {
        const fetchClientes = async () => {
            if (!tenantId) return;

            setLoading(true);
            setError(null);
            try {
                const response = await getClientes({
                    tenantId, limit
                });
                console.log('Response from API for clientes:', response);
                setClientes(response.records);
            } catch (err) {
                const errorMessage = `Failed to fetch clientes: ${err.message || 'Unknown error'}`;
                setError(errorMessage);
                console.error(errorMessage);
                setClientes(null);
            } finally {
                setLoading(false);
            }
        };

        fetchClientes();
    }, [tenantId, limit, refresh]);

    return { clientes, loading, error };
};

export default useObtenerClientes;